export enum TyreActivityType {
  New = 'new',
  Change = 'change',
  Season = 'season',
  Repair = 'repair',
  NonFit = 'non-fit'
}
